import { Box, Button, styled, Typography } from '@mui/material';

import { colors } from '../../../../theme';

export const Container = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`;

export const ButtonsContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FooterButton = styled(Button)`
  color: ${colors.orangeyYellow};
  width: 230px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background-color: ${colors.novajoWhite10};
  text-transform: capitalize;
  &.Mui-disabled {
    color: ${colors.dimGray};
    background-color: rgba(255, 220, 168, 0.05);
    opacity: 0.6;
    pointer-events: none;
  }
`;

export const FooterText = styled(Typography)`
  color: ${colors.white50};
  text-align: center;
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
`;

export const ConfirmText = styled(Box)`
  color: ${colors.white70};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  flexGrow: 1;
  margin: '10px 0px 0px 0px';
`;
